import React from 'react';
import './goal.css';

import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import FormControl from 'react-bootstrap/lib/FormControl';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import CurrencyFormat from 'react-currency-format';
import $ from 'jquery';


export default class GoalCalculator extends React.Component {

  constructor() {
    super();
    this.state = {
      fields: { rate: '12', year: '15', finalAmount: '100' },
      errors: {},
      amount: '19819'
    }
    this.handleChange = this.handleChange.bind(this);
  };

  handleChange = (e) => {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState(fields, function () {
      this.calculateGoal();
    }.bind(this));
  }

  validateForm = () => {

    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["rate"]) {
      formIsValid = false;
      errors["rate"] = "*Please enter Rate of Interest.";
    }

    if (typeof fields["rate"] !== "undefined") {
      if (fields["rate"].match(/^[a-zA-Z ]*$/)) {
        formIsValid = false;
        errors["rate"] = "*Please enter numbers only";
      }
    }

    if (!fields["year"]) {
      formIsValid = false;
      errors["year"] = "*Please enter Number of years.";
    }

    if (typeof fields["year"] !== "undefined") {
      if (fields["year"].match(/^[a-zA-Z ]*$/)) {
        formIsValid = false;
        errors["year"] = "*Please enter numbers only";
      }
    }

    this.setState({
      errors: errors
    });
    return formIsValid;

  }

  calculateGoal = () => {

    if (this.validateForm()) {
      var rate_of_return = (this.state.fields.rate) / 1200
      var time = (this.state.fields.year) * 12 
      var inflation_multiple = (1 + rate_of_return)
      var power_fuction = Math.pow(inflation_multiple, time) - 1
      var final = (this.state.fields.finalAmount * 100000) / ((power_fuction / rate_of_return) * inflation_multiple)
      this.setState({ amount: Math.round(final) })
    }
  }

  handleRange = (e) => {
    let fields = this.state.fields;
    fields['finalAmount'] = e.target.value;
    this.setState(fields, function () {
      this.calculateGoal();
    }.bind(this));
  }

  componentDidMount() {

    var rangeSlider = function () {
      var slider = $('.range-slider'),
        range = $('.range-slider__range'),
        value = $('.range-slider__value');

      slider.each(function () {

        value.each(function () {
          var value = $(this).prev().attr('value');
          $(this).html(value);
        });

        range.on('input', function () {
          $(this).next(value).html(this.value);
        });
      });
    };

    rangeSlider();

  }


  render() {

    const data = [{ name: 'SIP', value: (this.state.amount) * 12 * (this.state.fields.year) }, { name: 'Gain Amount', value: (this.state.fields.finalAmount * 100000) }];
    const COLORS = ['rgb(125, 115, 210)', '#332ba9'];

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);

      return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
          {`${(percent * 100).toFixed(0)}%`}
        </text>
      );
    };


    return (

      <div className='body2'>
        <div className='container'>
          <br />
          <br />
          <div align="center" id="calculator">
            <div className='text-center'>
              <h2>Set Goal And Know Your Monthly SIP Amount</h2>
            </div>
            <br />
            <br />
            <br />
            <Row>
              <Col md={6} sm={6} xs={12}>
                <div className="range-slider text-center">
                  <input className="range-slider__range" type="range" min="1" max="700" name="finalAmount" onChange={this.handleChange} value={this.state.fields.finalAmount} id="range_slider" />
                  <input type="message" onChange={this.handleRange.bind(this)} value={this.state.fields.finalAmount} className="range-slider__value2" /><span> Lakhs</span>
                  <h2>Goal Amount</h2>
                </div>
                <FormControl type="message" name="rate" placeholder="Rate *" onChange={this.handleChange} value={this.state.fields.rate} />
                <h2>Rate of Return</h2>
                <div className="errorMsg">{this.state.errors.rate}</div>
                <br />
                <br />
                <FormControl type="message" name="year" placeholder="Year *" onChange={this.handleChange} value={this.state.fields.year} />
                <h2>Investment Duration (Years)</h2>
                <div className="errorMsg">{this.state.errors.year}</div>
              </Col>
              <Col md={6} sm={6} xs={12}>
                <div className='d-none d-lg-block'>
                  <PieChart width={450} height={300}>
                    <Pie
                      data={data}
                      dataKey="value"
                      labelLine={false}
                      label={renderCustomizedLabel}
                      outerRadius={140}
                      fill="#8884d8"
                    >
                      {
                        data.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]} />)
                      }
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </div>
                <div className='d-none d-md-block d-lg-none'>
                  <PieChart width={320} height={292}>
                    <Pie
                      data={data}
                      dataKey="value"
                      labelLine={false}
                      label={renderCustomizedLabel}
                      outerRadius={140}
                      fill="#8884d8"
                    >
                      {
                        data.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]} />)
                      }
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </div>
                <div className='d-none d-sm-block d-md-none'>
                  <PieChart width={250} height={250}>
                    <Pie
                      data={data}
                      dataKey="value"
                      labelLine={false}
                      label={renderCustomizedLabel}
                      outerRadius={120}
                      fill="#8884d8"
                    >
                      {
                        data.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]} />)
                      }
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </div>
                <div className='d-block d-sm-none'>
                  <PieChart width={250} height={250}>
                    <Pie
                      data={data}
                      dataKey="value"
                      labelLine={false}
                      label={renderCustomizedLabel}
                      outerRadius={120}
                      fill="#8884d8"
                    >
                      {
                        data.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]} />)
                      }
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </div>
                {(this.state.fields.rate !== '' && this.state.fields.year !== '') ?
                  <CurrencyFormat value={this.state.amount} displayType={'text'} allowNegative={false} thousandSeparator={true} thousandSpacing='2s' prefix={'₹'} renderText={value => <div><h2>Sip Amount : {value}</h2></div>} />
                  :
                  <h2>Sip Amount: ₹</h2>
                }
              </Col>
            </Row>
            <br />
            <br />
          </div>
        </div>
      </div>

    );
  }
}




